export const carPropertySchema = {
  description: {
    type: "string",
    placeholder: "Car"
  },
  value: {
    type: "integer"
  },
  model_year: {
    type: "string"
  },
  type: {
    type: "string",
    defaultValue: "car"
  }
}
